import { render, staticRenderFns } from "./ContScoreModal.vue?vue&type=template&id=33b93552&scoped=true"
import script from "./ContScoreModal.vue?vue&type=script&lang=js"
export * from "./ContScoreModal.vue?vue&type=script&lang=js"
import style0 from "./ContScoreModal.vue?vue&type=style&index=0&id=33b93552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b93552",
  null
  
)

export default component.exports